module.exports = __webpack_public_path__ + "static/media/monkey-eating.b68c42eb.gif";